/**
* Featured Services JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Services component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'featured-services',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.featured-services' ).length ) {
        $( '.featured-services' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '32px',
            perPage: 3,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1269: {
                perPage: 2,
              },
              768: {
                perPage: 1,
                arrows: false,
              },
            },
          } ).mount( {} );

          const isMobile = window.matchMedia( '(max-width: 1023px)' ).matches;
          const prevBtn = isMobile ?
  document.querySelector( '.mobile-prev' ) :
  document.querySelector( '.desktop-prev' );
          const nextBtn = isMobile ?
  document.querySelector( '.mobile-next' ) :
  document.querySelector( '.desktop-next' );

          if ( prevBtn && nextBtn ) {
            prevBtn.addEventListener( 'click', () => splide.go( '<' ) );
            nextBtn.addEventListener( 'click', () => splide.go( '>' ) );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
